<template>
    <div>
        <p class="text-center mb-0">{{unidadeSelecionada.cnes}} - {{unidadeSelecionada.nome}}</p>
        <p class="text-center mb-0"><strong>Enfermaria:</strong> {{dados.leitoCodigoEnfermaria}} <strong>Leito:</strong> {{dados.leitoCodigo}}</p>
        <p class="text-center"><strong>{{dados.leitoNomeEnfermaria}}</strong></p>
        
        <div class="row">
            <div class="col-sm-12 form-group">
                <label for="motivoimpedimento">Motivo da Liberação</label>
                <textarea 
                    class="form-control" rows="4" 
                    id="motivoimpedimento"
                    :value="motivo"
                    @input="bindMotivo($event.target.value.toUpperCase())">
                </textarea>
                <small v-if="motivo == ''" class="text-danger">campo obrigatório</small>
            </div>
        </div>

        <button type="button" class="btn btn-primary" :disabled="motivo == '' ? true : false" @click.once="validaSessao('liberarLeito')">Liberar o Leito</button>

    </div>
</template>

<script>
import { validaSessao } from '../../../shared/mixins/validaSessao'

export default {
    props: {
        dados: Object
    },
    mixins: [
        validaSessao
    ],
    computed: {
        unidadeSelecionada () {
            return this.$store.getters['filtro/getUnidadeSelecionada']
        },
        motivo () {
            return this.$store.getters['liberar/getMotivo']
        }
    },
    methods: {
        bindMotivo(evento) {
            this.$store.commit("liberar/setMotivo", evento)
        },
        liberarLeito () {
            if (this.motivo == '') return

            let dados = {
                codigoEnfermaria: this.dados.leitoCodigoEnfermaria,
                codigoLeito: this.dados.leitoCodigo,
                motivoLiberacao: this.motivo
            }
  
            this.$emit('liberar', dados)
        }
    }
}
</script>